import * as React from "react";
import "./index.css";
import "graphiql/graphiql.min.css";
import GraphiQL from "graphiql";
import { createGraphiQLFetcher } from "@graphiql/toolkit";
import schemaData from "./introspection.json";

const data = schemaData.data
const __schema = data.__schema
__schema.types = __schema.types.map(
  function (t) {
    if (t.name === "Mutation") {
      let item = t.fields[0]
      item.description = "NOT AVAILABLE FOR PUBLIC API"
      t.fields = [item]
    }
    return t;
  }
)

const defaultQuery = `
{
  queryFundSubscription(first: 10) {
    id
    orders(first: 100) {
      mainContact {
        id
        email
        firstName
        lastName
      }
      status
    }
  }
}
`;

const DEMO_SERVER_URL = "https://api-demo.anduin.app/graphql"
const CANARY_SERVER_URL = "https://api-canary.anduin.dev/graphql"
const PRODUCTION_SERVER_URL = "https://api.anduin.app/graphql"

class GraphiQLWrapper extends React.Component {
  state = {url: DEMO_SERVER_URL}

  render() {
    const {url} = this.state
    console.log(url)
    return (
      <div style={{height: "100%"}}>
        <select 
          onChange={event => this.setState({url: event.target.value})}
          style={{
            position: "absolute",
            top: "12px",
            left: "500px"
          }}
        >
          <option value={CANARY_SERVER_URL}>
            Canary Server
          </option>
          <option value={DEMO_SERVER_URL} selected>
            Deals Demo Server
          </option>
          <option value={PRODUCTION_SERVER_URL}>
            Production Server
          </option>
        </select>
        <GraphiQL
          fetcher={
            createGraphiQLFetcher({
              url: url,
              schemaFetcher: (_) => schemaData,
            })}
          defaultQuery={defaultQuery}
          headerEditorEnabled
        />
      </div>
    )
  }
}

export default GraphiQLWrapper
